import { UserService } from "@/app/core/apis/user.service";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import posthog from "posthog-js";
import { of } from "rxjs";
import { catchError, map, switchMap, tap } from "rxjs/operators";
import { loadBusinessDetail, loadBusinessDetailSuccess, loadCurrentUser, loadCurrentUserFailure, loadCurrentUserSuccess } from "./auth.actions";

@Injectable()
export class AuthEffects {
  constructor(
    private actions$: Actions,
    private userService: UserService
  ) {}

  currentUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCurrentUser),
      switchMap(() =>
        this.userService.me().pipe(
          tap((user) => posthog.identify(user.id, { email: user.email, name: `${user.firstName} ${user.lastName}` })),
          map((user) => loadCurrentUserSuccess({ user })),
          catchError((error) => of(loadCurrentUserFailure({ error })))
        )
      )
    )
  );

  businessDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBusinessDetail),
      switchMap(({ businessId }) => this.userService.getBusinessDetail(businessId).pipe(map((business) => loadBusinessDetailSuccess({ business }))))
    )
  );
}
